module.exports = __webpack_public_path__ + "static/media/0027_Small.eac09d03.jpg";